import React from "react";

import {
  HistoryOutlined,
  QuestionCircleFilled,
  ShoppingCartOutlined,
  SwapOutlined,
} from "@ant-design/icons";

import { PREPAID_HOW_IT_WORKS_STEPS } from "../constants";

import "./UsageMetricsHowItWorksPanel.css";

const STEP_ICONS = {
  "buy-before-submission": <ShoppingCartOutlined />,
  "deducted-by-category": <HistoryOutlined />,
  "return-credits": <SwapOutlined />,
};

export default function UsageMetricsHowItWorksPanel({
  heading = "How Prepaid test works ?",
}) {
  return (
    <article className="UsageMetricsHowItWorksPanel">
      <span className="UsageMetricsHowItWorksPanel__Badge">
        <QuestionCircleFilled />
        {heading}
      </span>
      <ul className="UsageMetricsHowItWorksPanel__Steps">
        {PREPAID_HOW_IT_WORKS_STEPS.map((step) => (
          <li className="UsageMetricsHowItWorksPanel__Step" key={step.key}>
            <span className="UsageMetricsHowItWorksPanel__StepIcon">
              {STEP_ICONS[step.key]}
            </span>
            <div>
              <p className="UsageMetricsHowItWorksPanel__StepTitle">{step.title}</p>
              <p className="UsageMetricsHowItWorksPanel__StepDescription">{step.description}</p>
            </div>
          </li>
        ))}
      </ul>
    </article>
  );
}
